module.exports = __webpack_public_path__ + "img/20171229_172757.2abf232d.jpg";